import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../job-board.css';
import { jbApi } from '../api';
import { useJBAuth } from '../auth';

export default function SeekerAuthPage({ initialTab = 'login' }) {
  const navigate = useNavigate();
  const { login } = useJBAuth();
  const [tab, setTab]         = useState(initialTab);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [regForm, setRegForm]     = useState({
    first_name: '', last_name: '', email: '',
    password: '', location: '', headline: '',
  });

  const setL = k => e => setLoginForm(p => ({ ...p, [k]: e.target.value }));
  const setR = k => e => setRegForm(p => ({ ...p, [k]: e.target.value }));

  async function handleLogin(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await jbApi.seekerLogin({ email: loginForm.email, password: loginForm.password });
      const me  = await jbApi.me(res.access_token);
      login(res.access_token, res.role, me.profile);
      navigate('/seeker/dashboard');
    } catch (err) {
      setError(err.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  }

  async function handleRegister(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await jbApi.seekerRegister({
        first_name: regForm.first_name,
        last_name:  regForm.last_name,
        email:      regForm.email,
        password:   regForm.password,
        location:   regForm.location || undefined,
        headline:   regForm.headline || undefined,
      });
      const me = await jbApi.me(res.access_token);
      login(res.access_token, res.role, me.profile);
      navigate('/seeker/dashboard');
    } catch (err) {
      setError(err.detail || 'Registration failed. Please try again.');
    } finally { setLoading(false); }
  }

  return (
    <div className="jb-page" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'80vh', padding:20 }} data-testid="seeker-auth-page">
      <div style={{ width:'100%', maxWidth:480 }}>

        <div style={{ textAlign:'center', marginBottom:28 }}>
          <Link to="/career-hub" style={{ fontSize:12, color:'#1B6B72', fontWeight:700, textDecoration:'none', letterSpacing:'.08em', textTransform:'uppercase' }}>
            ← Career Hub
          </Link>
          <h1 style={{ fontFamily:'Inter,sans-serif', fontSize:26, fontWeight:800, color:'#0D2137', margin:'12px 0 4px' }}>Job Seeker Portal</h1>
          <p style={{ fontSize:14, color:'#5a6373', margin:0 }}>Track your applications. Land your next opportunity.</p>
        </div>

        <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 4px 24px rgba(13,33,55,.1)', padding:28 }}>
          <div className="jb-tabs">
            <button className={`jb-tab${tab==='login'?' active':''}`} onClick={() => { setTab('login'); setError(''); }} data-testid="tab-seeker-login">Log In</button>
            <button className={`jb-tab${tab==='register'?' active':''}`} onClick={() => { setTab('register'); setError(''); }} data-testid="tab-seeker-register">Create Account</button>
          </div>

          {error && <div className="jb-error-box" data-testid="seeker-auth-error">{error}</div>}

          {tab === 'login' && (
            <form onSubmit={handleLogin} data-testid="seeker-login-form">
              <div className="jb-form-group">
                <label className="jb-form-label">Email</label>
                <input className="jb-form-input" type="email" required value={loginForm.email} onChange={setL('email')} placeholder="you@example.com" data-testid="seeker-email" />
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Password</label>
                <input className="jb-form-input" type="password" required value={loginForm.password} onChange={setL('password')} placeholder="••••••••" data-testid="seeker-password" />
              </div>
              <button className="jb-btn-primary" type="submit" disabled={loading} data-testid="seeker-login-submit">
                {loading ? 'Logging in…' : 'Log In'}
              </button>
            </form>
          )}

          {tab === 'register' && (
            <form onSubmit={handleRegister} data-testid="seeker-register-form">
              <div className="jb-form-row">
                <div className="jb-form-group">
                  <label className="jb-form-label">First Name *</label>
                  <input className="jb-form-input" required value={regForm.first_name} onChange={setR('first_name')} placeholder="Alex" data-testid="seeker-reg-first-name" />
                </div>
                <div className="jb-form-group">
                  <label className="jb-form-label">Last Name *</label>
                  <input className="jb-form-input" required value={regForm.last_name} onChange={setR('last_name')} placeholder="Johnson" data-testid="seeker-reg-last-name" />
                </div>
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Email *</label>
                <input className="jb-form-input" type="email" required value={regForm.email} onChange={setR('email')} placeholder="you@example.com" data-testid="seeker-reg-email" />
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Headline</label>
                <input className="jb-form-input" value={regForm.headline} onChange={setR('headline')} placeholder="e.g. Recent grad seeking Healthcare roles" data-testid="seeker-reg-headline" />
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Location</label>
                <input className="jb-form-input" value={regForm.location} onChange={setR('location')} placeholder="e.g. Atlanta, GA" data-testid="seeker-reg-location" />
              </div>
              <div className="jb-form-group">
                <label className="jb-form-label">Password *</label>
                <input className="jb-form-input" type="password" required minLength={8} value={regForm.password} onChange={setR('password')} placeholder="Min. 8 characters" data-testid="seeker-reg-password" />
              </div>
              <button className="jb-btn-primary" type="submit" disabled={loading} data-testid="seeker-register-submit">
                {loading ? 'Creating account…' : 'Create Account'}
              </button>
            </form>
          )}
        </div>

        <p style={{ textAlign:'center', fontSize:12, color:'#94a3b8', marginTop:16 }}>
          Hiring? <Link to="/employer/login" style={{ color:'#1B6B72', fontWeight:600 }}>Employer portal →</Link>
        </p>
      </div>
    </div>
  );
}
